module.exports = __webpack_public_path__ + "static/media/NE.6e160500.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NE.svg
// module id = 2224
// module chunks = 7